interface EditorActionVisibility {
  hasEditorRole: boolean;
  isSharedLink: boolean;
  isAuthenticated: boolean;
}

export const canShowEditorMutationActions = ({
  hasEditorRole,
  isSharedLink,
  isAuthenticated,
}: EditorActionVisibility): boolean => hasEditorRole && (!isSharedLink || isAuthenticated);
